
import { ProductVariant } from '../../../app-layer/util/typings';
import { formatMoney } from '../../utils/currency';

const updatePrice = (priceEls: NodeListOf<Element>, compareAtPriceEls: NodeListOf<Element>, format: string) => ((variant: ProductVariant): void => {
  const isOnSale = variant.compare_at_price && variant.compare_at_price > variant.price ? true : false;
  const discountSticker = document.querySelector('[data-product-discount]');
  const salePrice = variant.compare_at_price - variant.price;
  const saleFraction = salePrice / variant.compare_at_price;
  const saleRound = Math.round(saleFraction * 100) / 100
  const salePercentage = Math.round(saleRound * 100).toString();
  const compareWrapper = document.querySelector('[data-product-compare]')
  const qtySelector = document.querySelector('[data-price-adjust]') as HTMLInputElement;

  priceEls.forEach(priceEl => {
    isOnSale ? priceEl.classList.add('product-details-price-snippet__price--sale') : priceEl.classList.remove('product-details-price-snippet__price--sale')
    priceEl.innerHTML = formatMoney(variant.price, format)
    qtySelector.dataset.priceAdjust = variant.price.toString();
    qtySelector.value = '1';
  });
  compareAtPriceEls.forEach(compareAtPriceEl => compareAtPriceEl.innerHTML = variant.compare_at_price && variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price, format) : '')
  if (isOnSale) {
    discountSticker.classList.remove('hide')
    discountSticker.innerHTML = `Save ${salePercentage}%`
    compareWrapper.classList.remove('hide')
  } else {
    discountSticker.classList.add('hide')
    compareWrapper.classList.add('hide')
  }
})

export default updatePrice;